var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconChevronMedium = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#FF3118",
  viewBox: "0 0 28 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26 4a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v22.844c0 1 1.155 1.522 1.875.861L14 18.281l10.125 9.409c.72.677 1.875.154 1.875-.846z"
})));
export default SvgIconChevronMedium;